/** SPEC §15: licht, donker of zoals het systeem; per browser onthouden. */
import { useSyncExternalStore } from 'react';
import { huisstijlVariabelen } from '@ep/core';

export type Thema = 'licht' | 'donker' | 'systeem';
type Huisstijl = { primair?: string | null; accent?: string | null } | null | undefined;

const SLEUTEL = 'ep-thema';
const media = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
const luisteraars = new Set<() => void>();
let huidigeHuisstijl: Huisstijl = null;
let afdrukken = false;

function lees(): Thema {
  try {
    const t = localStorage.getItem(SLEUTEL);
    return t === 'licht' || t === 'donker' || t === 'systeem' ? t : 'systeem';
  } catch {
    return 'systeem';
  }
}
let thema: Thema = lees();

export const isDonker = (t: Thema = thema) => !afdrukken && (t === 'donker' || (t === 'systeem' && !!media?.matches));

/** Zet thema en kleuren op <html>. */
export function pasToe(hs?: Huisstijl) {
  if (hs !== undefined) huidigeHuisstijl = hs;
  const donker = isDonker();
  const root = document.documentElement;
  root.dataset.thema = donker ? 'donker' : 'licht';
  for (const [k, v] of Object.entries(huisstijlVariabelen(huidigeHuisstijl, donker))) root.style.setProperty(k, v);
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', donker ? '#0E131D' : huisstijlVariabelen(huidigeHuisstijl)['--accent']);
}

function melden() {
  pasToe();
  luisteraars.forEach((f) => f());
}

export function zetThema(t: Thema) {
  thema = t;
  try {
    localStorage.setItem(SLEUTEL, t);
  } catch {
    /* geen opslag: alleen voor nu */
  }
  melden();
}

if (typeof window !== 'undefined') {
  media?.addEventListener?.('change', () => thema === 'systeem' && melden());
  // afdrukken altijd licht
  window.addEventListener('beforeprint', () => {
    afdrukken = true;
    pasToe();
  });
  window.addEventListener('afterprint', () => {
    afdrukken = false;
    pasToe();
  });
  pasToe(null);
}

export function useThema(): [Thema, (t: Thema) => void] {
  const t = useSyncExternalStore(
    (f) => {
      luisteraars.add(f);
      return () => luisteraars.delete(f);
    },
    () => thema,
  );
  return [t, zetThema];
}
